import { DmpHlFindPatientResponseSIns } from "./dmp-hl-find-patient-response.interface";

export interface DmpHlUpdateUserAccessAuthorizationParams {
  s_ins: DmpHlFindPatientResponseSIns;
  i_setTreatingPhysician: boolean;
  i_action: DmpAuthorizationActionEnum;
}

export enum DmpAuthorizationActionEnum {
  'ajouter autorisation' = 1,
  'retirer autorisation' = 2,
}
